import { Navigate, Outlet } from 'react-router-dom';
import { getLocalStorage } from '../../utils/utils';

export const Layout = () => {
  const token = getLocalStorage('token');
  return token ? <Outlet /> : <Navigate to="/" />;
};
